<template>
    <div class="bg-gray-100 border border-t border-l-0 border-r-0 border-b-0 border-gray-300 rounded-md rounded-t-none">
        <slot/>
    </div>
</template>

<script>
export default {}
</script>
